// Card #1652 (design §6.1) — shared component vocabulary. Renders the
// `entryIdentity` bundle score-api composes as ONE selectable field (CNO +
// riderName + riderStatus + horseName, score-api's lib/scoreboard-mode-payload.js
// composeEntryIdentity):
// each sub-key that bundle omitted is individually ABSENT from the DOM here
// (AC3 — never rendered empty/null), and the whole component renders
// nothing at all when literally none of the four are present (matching
// composeEntryIdentity's own "return undefined if nothing resolves").
import "./EntryIdentity.css";

export default function EntryIdentity({ competitorNumber, riderName, riderStatus, horseName }) {
  const hasAnything = competitorNumber != null || !!riderName || !!riderStatus || !!horseName;
  if (!hasAnything) return null;

  return (
    <div className="entry-identity" data-testid="entry-identity">
      {competitorNumber != null ? (
        <span className="entry-identity__cno" data-testid="entry-identity-cno">
          #{competitorNumber}
        </span>
      ) : null}
      {riderName ? (
        <span className="entry-identity__rider" data-testid="entry-identity-rider">
          {riderName}
        </span>
      ) : null}
      {riderStatus ? (
        <span className="entry-identity__status" data-testid="entry-identity-status">
          {riderStatus}
        </span>
      ) : null}
      {horseName ? (
        <span className="entry-identity__horse" data-testid="entry-identity-horse">
          {horseName}
        </span>
      ) : null}
    </div>
  );
}
